




































import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import { user } from "@/store/types";
import axios from 'axios';
import {MutationList as ModalMutations} from "@/store/modules/modal/mutation-list";

@Component
export default class EditFamilyMember extends Vue{
    @Prop(String) readonly user!: string;

    private userNamespace = 'root/';
    private modalNamespace = 'modal/';

    private relativeUser: user = {
        name: '',
        surname: '',
        address: ''
    };

    // watcher to populate relativeUser var to make it able to be edited.
    @Watch('user')
    saveWatcher() {
        this.relativeUser.name = this.relative.name;
        this.relativeUser.surname = this.relative.surname;
        this.relativeUser.surname = this.relative.address;
    }

    // get that relative user
    get relative(): user {
        return this.$store.getters[`${this.userNamespace}getUser`](parseInt(this.user));
    }

    async saveChanges() {
        this.$store.commit(`${this.modalNamespace}${ModalMutations.SELECT_LOADING_MODAL}`, 'processing request');

        await axios.post('https://dev.palmamedical.lv/api/rest/user/members/id/patch', this.relativeUser)
            .then(() => {
                this.$store.commit(`${this.modalNamespace}${ModalMutations.SET_MODAL_VISIBILITY_FALSE}`);
                this.$store.commit(`${this.modalNamespace}${ModalMutations.SELECT_SMALL_MODAL}`, {
                    message: `Changes Saved`,
                    title: 'Success!!'
                });
            })
            .catch(e => {
                this.$store.commit(`${this.modalNamespace}${ModalMutations.SELECT_MESSAGING_MODAL}`, {
                    header: 'an error happened',
                    message: e
                });
            });
    }

    // back to members list
    back(){
        this.$router.replace('/members');
    }
}
